import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Fab, ListItem } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import ListItemIcon from '@mui/material/ListItemIcon'
import { Theme } from '@mui/material/styles'
import { colors } from '@global/constants'

const FAB_HEIGHT = 22

export const ActionButtonsContainer = styled.div<{ theme?: Theme }>`
  display: flex;
  justify-content: flex-end;
  padding: 12px;

  > :nth-of-type(n + 2) {
    margin-left: ${props => props.theme.spacing(1)};
  }
`

export const FilterListItem = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10px;
`

export const ComparisonOperatorFormControl = styled(FormControl)`
  width: 260px;
`

export const FilterListItemUser = styled(ListItem)`
  padding-right: 10px;

  > :nth-of-type(n + 2) {
    margin-left: 10px;
  }
`

export const FilterListItemButtons = styled.div`
  display: flex;
  align-items: center;

  > :nth-of-type(n + 2) {
    margin-left: 4px;
  }
`

export const FilterListItemIcon = styled(ListItemIcon)`
  min-width: 30px;
`

export const PopoverContent = styled.form`
  width: 450px;
`

export const RemoveFab = styled(Fab)`
  padding: 2px;
  width: ${FAB_HEIGHT}px;
  height: ${FAB_HEIGHT}px;
  min-height: ${FAB_HEIGHT}px;
  color: white;
  background-color: ${colors.red.main};

  &:hover {
    background-color: ${colors.red.dark};
  }
`

export const AddFab = styled(Fab)`
  padding: 2px;
  width: ${FAB_HEIGHT}px;
  height: ${FAB_HEIGHT}px;
  min-height: ${FAB_HEIGHT}px;
`

export const flexStart = css`
  align-items: flex-start;
`

export const flexEnd = css`
  align-items: flex-end;
`
